module.exports = __webpack_public_path__ + "50f6a642e784e4860e214cf0fad4b78b.svg";